<template>
  <div class="sorteos-globales">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaSorteoDesde="fechaSorteoDesdeParam"
          :fechaSorteoHasta="fechaSorteoHastaParam"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Sorteos Globales">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="sorteosGlobales" 
              :fields="sorteosGlobalesFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaSorteo)="data">
              {{ data.item.fechaSorteo | fecha }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item 
                    :disabled="data.item.sorteado" 
                    @click.stop="editarItem(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Sorteo</b-dropdown-item>

                <b-dropdown-item @click.stop="consultarEventos(data.item)">
                  <i class="fa fa-calendar"></i>Consultar Eventos</b-dropdown-item>

                <b-dropdown-item 
                    v-if="!data.item.sorteado" 
                    @click.stop="sortear(data.item)">
                  <i class="fa fa-trophy"></i>Sortear</b-dropdown-item>

                <b-dropdown-item 
                    v-if="data.item.sorteado" 
                    @click.stop="consultarSorteo(data.item)">
                  <i class="fa fa-trophy"></i>Consultar Sorteo</b-dropdown-item>
              </b-dropdown>
            </template>            
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Sorteo Global</b-dropdown-item>
          <!-- <b-dropdown-item @click.stop="agregarCompra">
            <i class="fa fa-plus"></i>Comprobante de Compras</b-dropdown-item>
          <b-dropdown-item @click.stop="agregarCompraRemitos">
            <i class="fa fa-plus"></i>Comprobante de Facturación de Remitos</b-dropdown-item> -->
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="sorteoModal" 
        title="Sorteo del Evento"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-sorteo
        :eventoId="0"
        :sorteoGlobalId="sorteoGlobalId"
        @close="closeSorteo">
      </app-sorteo>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Sorteo from '../sorteos/SorteoABM.vue';
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'sorteosGlobales/getField',
  mutationType: 'sorteosGlobales/updateField',
});

export default {
  name: 'SorteosGlobales',
  components: {
    appSorteo: Sorteo,
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      sorteosGlobalesFields: [
        { 
          key: 'id',
          label: 'Nro.'
        },
        { key: 'cliente'},
        { key: 'nombre'},
        { 
          key: 'tipoEvento',
          label: 'Tipo de Evento'
        },
        { key: 'fechaSorteo'},
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      sorteoGlobalId: 0
    }
  },
  computed: {
    ...mapFields([
      'sorteosGlobales',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaSorteoDesde',
      'fechaSorteoHasta',
      'sortByDescending'
    ]),
    fechaSorteoDesdeParam() {
      return moment(this.fechaSorteoDesde).format('YYYY-MM-DD');
    },
    fechaSorteoHastaParam() {
      return moment(this.fechaSorteoHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaSorteoDesde = moment(filtro.fechaSorteoDesde).format('YYYY-MM-DD'),
      this.fechaSorteoHasta = moment(filtro.fechaSorteoHasta).format('YYYY-MM-DD'),
      this.sortByDescending = filtro.sortByDescending;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('sorteosGlobales/getSorteosGlobales')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'SorteoGlobalABM', 
                          params: { id: 0 }});
    },
    editarItem (item) {
      this.$router.push({ name: 'SorteoGlobalABM', 
                          params: { id: item.id }});
    },
    consultar (item) {
      this.$router.push({ name: 'SorteoGlobalDatos', 
                          params: { id: item.id }});
    },
    consultarEventos (item) {
      this.$router.push({ name: 'SorteoGlobalEventos', 
                          params: { sorteoGlobalId: item.id }});
    },

    sortear (item) {
      /* Validamos si el cliente es DTV, mostramos el form con las opciones del sorteo */
      let clienteId = this.$store.getters['user/clienteId'];

      if (clienteId == 1) {
        /* Mostramos las opciones del sorteo */
        this.sorteoGlobalId = item.id;
        this.$refs.sorteoModal.show();
      } else {
        this.showModalConfirm('¿Desea realizar el sorteo del sorteo global seleccionado?', 
              this.sortearEvento.bind(this, item), 'Si', 
              null, 'No')
      }
    },
    sortearEvento(item) {
        /* Sorteamos el evento */
        let params = {
          eventoId: 0,
          sorteoGlobalId: item.id,
          soloClientes: false,
          dobleChanceClientes: false
        }

        this.showSpinner();
        this.$store.dispatch('sorteo/sortear', params)
          .then(()  => this.showModalMsj('El sorteo se completó éxito.', 
            this.consultarSorteo.bind(this, item), this.consultarSorteo.bind(this, item), 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
    },
    closeSorteo(sorteado) {
      this.$refs.sorteoModal.hide();
      if (sorteado) {
        this.$router.push({ name: 'ResultadosSorteoGlobalSorteo', 
                            params: { sorteoGlobalId: this.sorteoGlobalId }});
      }
    },
    consultarSorteo (item) {
      this.$router.push({ name: 'ResultadosSorteoGlobalSorteo', 
                          params: { sorteoGlobalId: item.id }});
    },

    // consultarSorteo (item) {
    //   this.$router.push({ name: 'SorteoGlobalSorteo', 
    //                       params: { sorteoGlobalId: item.id }});
    // },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .sorteos-globales .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .sorteos-globales .registro table td[aria-colindex="2"] {
    width: 20%;
  }
  .sorteos-globales .registro table td[aria-colindex="3"] {
    width: Calc(30% - 30px);
  }
  .sorteos-globales .registro table td[aria-colindex="4"] {
    width: 15%;
  }
  .sorteos-globales .registro table td[aria-colindex="5"] {
    width: 15%;
  }
  .sorteos-globales .registro table td[aria-colindex="6"] {
    width: 30px;
  }

</style>
